const breakpoints = ['576px', '768px', '992px', '1200px']
breakpoints.sm = breakpoints[0]
breakpoints.md = breakpoints[1]
breakpoints.lg = breakpoints[2]
breakpoints.xl = breakpoints[3]
breakpoints.variants = ['sm', 'md', 'lg', 'xl']

const fontWeights = [400, 600, 700]
fontWeights.regular = fontWeights[0]
fontWeights.semibold = fontWeights[1]
fontWeights.bold = fontWeights[2]

const textFontSizes = [12, 14, 16, 22]
const headerFontSizes = [18, 22, 34, 48]
const fontSizes = [...textFontSizes, ...headerFontSizes]
fontSizes.text = {
  small: textFontSizes[0],
  regular: textFontSizes[1],
  medium: textFontSizes[2],
  large: textFontSizes[3]
}
fontSizes.header = {
  small: headerFontSizes[0],
  regular: headerFontSizes[1],
  medium: headerFontSizes[2],
  large: headerFontSizes[3]
}

const textLineHeight = ['20px', '22px', '24px', '32px']
const headerLineHeight = ['26px', '32px', '48px', '68px']
const lineHeights = [...textLineHeight, ...headerLineHeight]
lineHeights.text = {
  small: textLineHeight[0],
  regular: textLineHeight[1],
  medium: textLineHeight[2],
  large: textLineHeight[3]
}
lineHeights.header = {
  small: headerLineHeight[0],
  regular: headerLineHeight[1],
  medium: headerLineHeight[2],
  large: headerLineHeight[3]
}

const letterSpacings = [0, -0.1]
letterSpacings.text = letterSpacings[0]
letterSpacings.header = letterSpacings[1]

export default {
  fontFamily: 'Muli',
  breakpoints,
  fontWeights,
  fontSizes,
  letterSpacings,
  lineHeights,
  colors: {
    'light-1': '#ffffff',
    'light-3': 'rgba(255, 255, 255, 0.32)',
    'dark-1-1': 'rgba(26, 26, 26, 1)',
    'dark-1-4': 'rgba(26, 26, 26, 0.1)',
    'dark-2-1': '#172b4d',
    'dark-2-2': 'rgba(0, 85, 255, 0.08)',
    'primary-1': '#0055ff',
  }
}